import * as React from 'react';
import styled from 'styled-components';
import { Card } from '@mui/material';
import { Flex, Image } from 'antd';
import { Link } from 'react-router-dom';
import { MagazineType } from '../../../../common/types';
import { fonts } from '../../assets/constStyles';
import { paths } from '../../consts';

const DivStyled = styled(Flex)`
  min-width: 350px;
  width: 30%;
  flex-direction: column;
  flex: 1;

  //.ant-image{
  //  width: 100%;
  //  height: 100%;
  //}
  //
  //.ant-image-img {
  //  width: 100%;
  //  height: 100%;
  //}
`;

const CardStyled = styled(Card)`
  width: 100%;
  box-shadow: rgba(145, 158, 171, 0.3) 0 0 2px 0, rgba(145, 158, 171, 0.12) 0 12px 24px -4px;
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  position: relative;
  padding: 30px;
  height: 100%;
  //overflow: hidden;

  && * {
    font-family: ${fonts.font2} !important;
  }
`;

const PStyled = styled.p`
  font-size: 16px;
  font-weight: bolder;
  margin-top: 10px;
`;

interface MagazineCardItemProps {
  magazine: MagazineType,
}

export const MagazineCardItem: React.FC<MagazineCardItemProps> = ({ magazine }) => {
  const magazineImagesFolder = `${process.env.REACT_APP_S3_STORAGE_URL_MAGAZINE}/${process.env.REACT_APP_BUCKET_MAGAZINE}/${magazine.id}`;

  return (
        <DivStyled>
            <Link to={`${paths.MAGAZINES}/${magazine.id}`} >
            <CardStyled>
                <Image src={`${magazineImagesFolder}/1.png`} preview={false} style={{ width: '100%', objectFit: 'cover' }}/>
                <PStyled>{magazine.caption}</PStyled>
            </CardStyled>
            </Link>
        </DivStyled>
  );
};
